module.exports = __webpack_public_path__ + "img/Textur3D.447abdc9.png";